var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c = {}, $13c40c34b78c8ee2$var$s = [], $13c40c34b78c8ee2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$h = Array.isArray;
function $13c40c34b78c8ee2$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$d(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$m(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$m(n) : null;
}
function $13c40c34b78c8ee2$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$k(n);
    }
}
function $13c40c34b78c8ee2$var$w(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$x.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$x);
}
function $13c40c34b78c8ee2$var$x() {
    var n, u, t, o, r, e, c, s, a;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (u = $13c40c34b78c8ee2$var$i.length, o = void 0, e = (r = (t = n).__v).__e, s = [], a = [], (c = t.__P) && ((o = $13c40c34b78c8ee2$var$v({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$L(c, o, r, t.__n, void 0 !== c.ownerSVGElement, 32 & r.__u ? [
        e
    ] : null, s, null == e ? $13c40c34b78c8ee2$var$m(r) : e, !!(32 & r.__u), a), o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$M(s, o, a), o.__e != e && $13c40c34b78c8ee2$var$k(o)), $13c40c34b78c8ee2$var$i.length > u && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$x.__r = 0;
}
function $13c40c34b78c8ee2$var$C(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $13c40c34b78c8ee2$var$s, b = l.length;
    for(u.__d = e, $13c40c34b78c8ee2$var$P(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $13c40c34b78c8ee2$var$c : g[y.__i] || $13c40c34b78c8ee2$var$c, y.__i = v, $13c40c34b78c8ee2$var$L(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $13c40c34b78c8ee2$var$z(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $13c40c34b78c8ee2$var$S(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $13c40c34b78c8ee2$var$P(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $13c40c34b78c8ee2$var$d(null, i, null, null, i) : $13c40c34b78c8ee2$var$h(i) ? $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $13c40c34b78c8ee2$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $13c40c34b78c8ee2$var$H(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$m(o)), $13c40c34b78c8ee2$var$N(o, o, !1), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$m(o)), $13c40c34b78c8ee2$var$N(o, o));
}
function $13c40c34b78c8ee2$var$S(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$S(t[i], l, u));
        return l;
    }
    return n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e), l && l.nextSibling;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$h(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$H(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$a.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$T(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$I(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $13c40c34b78c8ee2$var$D : $13c40c34b78c8ee2$var$A, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$D : $13c40c34b78c8ee2$var$A, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $13c40c34b78c8ee2$var$A(n) {
    var u = this.l[n.type + !1];
    if (n.t) {
        if (n.t <= u.u) return;
    } else n.t = Date.now();
    return u($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$D(n) {
    return this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$L(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, k, w, x, P, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (w = u.props, x = (a = A.contextType) && i[a.__c], P = a ? x ? x.props.value : a.__ : i, t.__c ? k = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(w, P) : (u.__c = p = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(w, P), p.constructor = A, p.render = $13c40c34b78c8ee2$var$O), x && x.sub(p), p.props = w, p.state || (p.state = {}), p.context = P, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $13c40c34b78c8ee2$var$v({}, p.__s)), $13c40c34b78c8ee2$var$v(p.__s, A.getDerivedStateFromProps(w, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && w !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(w, P), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(w, p.__s, P) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = w, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(w, p.__s, P), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = P, p.props = w, p.__P = n, p.__e = !1, $ = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $13c40c34b78c8ee2$var$v($13c40c34b78c8ee2$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $13c40c34b78c8ee2$var$C(n, $13c40c34b78c8ee2$var$h(T = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), k && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$j(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$M(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$z(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$j(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, k = t.props, w = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(w);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, w.is && w), r = null, e = !1;
    }
    if (null === x) k === w || e && l.data === w || (l.data = w);
    else {
        if (r = r && $13c40c34b78c8ee2$var$n.call(l.childNodes), k = t.props || $13c40c34b78c8ee2$var$c, !e && null != r) for(k = {}, a = 0; a < l.attributes.length; a++)k[(_ = l.attributes[a]).name] = _.value;
        for(a in k)_ = k[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in w || $13c40c34b78c8ee2$var$T(l, a, null, _, o));
        for(a in w)_ = w[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || k[a] === _ || $13c40c34b78c8ee2$var$T(l, a, _, k[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $13c40c34b78c8ee2$var$C(l, $13c40c34b78c8ee2$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $13c40c34b78c8ee2$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $13c40c34b78c8ee2$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== k[a]) && $13c40c34b78c8ee2$var$T(l, a, g, k[a], !1), a = "checked", void 0 !== b && b !== l[a] && $13c40c34b78c8ee2$var$T(l, a, b, k[a], !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$z(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$z(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$N(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $13c40c34b78c8ee2$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$L(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$M(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$s.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$v({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$v({}, u), this.props)), n && $13c40c34b78c8ee2$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$x.__r = 0, $13c40c34b78c8ee2$var$e = 0;


var $46eb45435212d36d$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $46eb45435212d36d$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $46eb45435212d36d$var$t = new Map;
function $46eb45435212d36d$export$2e2bcd8739ae039(s) {
    var r = $46eb45435212d36d$var$t.get(this);
    return r || (r = new Map, $46eb45435212d36d$var$t.set(this, r)), (r = $46eb45435212d36d$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $5d836d6e65da64f6$export$c0bb0b647f701bb5 = (0, $46eb45435212d36d$export$2e2bcd8739ae039).bind((0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d));




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = [], $204a33a7557cbbd0$var$e = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b, $204a33a7557cbbd0$var$a = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r, $204a33a7557cbbd0$var$v = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed, $204a33a7557cbbd0$var$l = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c, $204a33a7557cbbd0$var$m = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount;
function $204a33a7557cbbd0$var$d(t, u) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__h($204a33a7557cbbd0$var$r, t, $204a33a7557cbbd0$var$o || u), $204a33a7557cbbd0$var$o = 0;
    var i = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $204a33a7557cbbd0$var$c
    }), i.__[t];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$B, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $204a33a7557cbbd0$var$r.u = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__H.__h.push(o));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__h.push(o));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(t, r) {
    (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$b() {
    for(var t; t = $204a33a7557cbbd0$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($204a33a7557cbbd0$var$k), t.__H.__h.forEach($204a33a7557cbbd0$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $204a33a7557cbbd0$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$k), i.__h.forEach($204a33a7557cbbd0$var$w), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).diffed = function(t) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(o) && $204a33a7557cbbd0$var$i === (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame || (($204a33a7557cbbd0$var$i = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).requestAnimationFrame) || $204a33a7557cbbd0$var$j)($204a33a7557cbbd0$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $204a33a7557cbbd0$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $204a33a7557cbbd0$var$c;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($204a33a7557cbbd0$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(t, r);
}, (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).unmount = function(t) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $204a33a7557cbbd0$var$g = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$g && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$k(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$w(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}




var $044786338e0e8fe2$var$a = {};
function $044786338e0e8fe2$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $044786338e0e8fe2$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $044786338e0e8fe2$var$d(n.replace(o, "")), t = $044786338e0e8fe2$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $044786338e0e8fe2$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $044786338e0e8fe2$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $044786338e0e8fe2$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $044786338e0e8fe2$var$d(n.props.path).map($044786338e0e8fe2$var$l).join("");
    }(n), n.props;
}
function $044786338e0e8fe2$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $044786338e0e8fe2$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $044786338e0e8fe2$var$p = {}, $044786338e0e8fe2$var$m = [], $044786338e0e8fe2$var$y = [], $044786338e0e8fe2$var$U = null, $044786338e0e8fe2$var$g = {
    url: $044786338e0e8fe2$export$dc90482e4ef07afd()
}, $044786338e0e8fe2$var$k = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)($044786338e0e8fe2$var$g);
function $044786338e0e8fe2$export$9a302a45f65d0572() {
    var n = (0, $204a33a7557cbbd0$export$fae74005e78b1a27)($044786338e0e8fe2$var$k);
    if (n === $044786338e0e8fe2$var$g) {
        var t = (0, $204a33a7557cbbd0$export$60241385465d0a34)()[1];
        (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(function() {
            return $044786338e0e8fe2$var$y.push(t), function() {
                return $044786338e0e8fe2$var$y.splice($044786338e0e8fe2$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $044786338e0e8fe2$export$4cb887bfde2d34ca
    ];
}
function $044786338e0e8fe2$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.location ? $044786338e0e8fe2$var$U.location : $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U.getCurrentLocation ? $044786338e0e8fe2$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $044786338e0e8fe2$var$p).pathname || "") + (n.search || "");
}
function $044786338e0e8fe2$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $044786338e0e8fe2$var$m.length; t--;)if ($044786338e0e8fe2$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $044786338e0e8fe2$var$U && $044786338e0e8fe2$var$U[t] ? $044786338e0e8fe2$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $044786338e0e8fe2$var$I(n);
}
function $044786338e0e8fe2$var$I(n) {
    for(var t = !1, r = 0; r < $044786338e0e8fe2$var$m.length; r++)$044786338e0e8fe2$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $044786338e0e8fe2$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $044786338e0e8fe2$export$4cb887bfde2d34ca(t);
    }
}
function $044786338e0e8fe2$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $044786338e0e8fe2$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($044786338e0e8fe2$var$M(t)) return $044786338e0e8fe2$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $044786338e0e8fe2$var$w = !1;
function $044786338e0e8fe2$export$55185c17a0fcbe46(n) {
    n.history && ($044786338e0e8fe2$var$U = n.history), this.state = {
        url: n.url || $044786338e0e8fe2$export$dc90482e4ef07afd()
    };
}
$044786338e0e8fe2$var$c($044786338e0e8fe2$export$55185c17a0fcbe46.prototype = new (0, $13c40c34b78c8ee2$export$16fa2f45be04daa8), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $13c40c34b78c8ee2$export$47e4c5b300681277)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $044786338e0e8fe2$var$w || ($044786338e0e8fe2$var$w = !0, $044786338e0e8fe2$var$U || addEventListener("popstate", function() {
            $044786338e0e8fe2$var$I($044786338e0e8fe2$export$dc90482e4ef07afd());
        }), addEventListener("click", $044786338e0e8fe2$var$W)), $044786338e0e8fe2$var$m.push(this), $044786338e0e8fe2$var$U && (this.u = $044786338e0e8fe2$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $044786338e0e8fe2$var$m.splice($044786338e0e8fe2$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($044786338e0e8fe2$var$v).sort($044786338e0e8fe2$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $044786338e0e8fe2$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $13c40c34b78c8ee2$export$47e4c5b300681277)(n.children), a);
        if (h && (u = (0, $13c40c34b78c8ee2$export$e530037191fcd5d7)(h[0], $044786338e0e8fe2$var$c($044786338e0e8fe2$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $044786338e0e8fe2$var$c($044786338e0e8fe2$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $044786338e0e8fe2$var$y.length; v--;)$044786338e0e8fe2$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($044786338e0e8fe2$var$k.Provider, {
            value: s
        }, u);
    }
});
var $044786338e0e8fe2$export$a6c7ac8248d6e38a = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("a", $044786338e0e8fe2$var$c({
        onClick: $044786338e0e8fe2$var$W
    }, n));
}, $044786338e0e8fe2$export$e7b0ac011bb776c6 = function(n) {
    return (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)(n.component, n);
};


/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $33893b708b33402d$var$isArray(value) {
    return !Array.isArray ? $33893b708b33402d$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $33893b708b33402d$var$INFINITY = 1 / 0;
function $33893b708b33402d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$33893b708b33402d$var$INFINITY ? "-0" : result;
}
function $33893b708b33402d$var$toString(value) {
    return value == null ? "" : $33893b708b33402d$var$baseToString(value);
}
function $33893b708b33402d$var$isString(value) {
    return typeof value === "string";
}
function $33893b708b33402d$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $33893b708b33402d$var$isBoolean(value) {
    return value === true || value === false || $33893b708b33402d$var$isObjectLike(value) && $33893b708b33402d$var$getTag(value) == "[object Boolean]";
}
function $33893b708b33402d$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $33893b708b33402d$var$isObjectLike(value) {
    return $33893b708b33402d$var$isObject(value) && value !== null;
}
function $33893b708b33402d$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $33893b708b33402d$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $33893b708b33402d$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $33893b708b33402d$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $33893b708b33402d$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $33893b708b33402d$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $33893b708b33402d$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $33893b708b33402d$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $33893b708b33402d$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $33893b708b33402d$var$hasOwn = Object.prototype.hasOwnProperty;
class $33893b708b33402d$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $33893b708b33402d$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $33893b708b33402d$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($33893b708b33402d$var$isString(key) || $33893b708b33402d$var$isArray(key)) {
        src = key;
        path = $33893b708b33402d$var$createKeyPath(key);
        id = $33893b708b33402d$var$createKeyId(key);
    } else {
        if (!$33893b708b33402d$var$hasOwn.call(key, "name")) throw new Error($33893b708b33402d$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($33893b708b33402d$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($33893b708b33402d$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $33893b708b33402d$var$createKeyPath(name);
        id = $33893b708b33402d$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $33893b708b33402d$var$createKeyPath(key) {
    return $33893b708b33402d$var$isArray(key) ? key : key.split(".");
}
function $33893b708b33402d$var$createKeyId(key) {
    return $33893b708b33402d$var$isArray(key) ? key.join(".") : key;
}
function $33893b708b33402d$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$33893b708b33402d$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$33893b708b33402d$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($33893b708b33402d$var$isString(value) || $33893b708b33402d$var$isNumber(value) || $33893b708b33402d$var$isBoolean(value))) list.push($33893b708b33402d$var$toString(value));
            else if ($33893b708b33402d$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $33893b708b33402d$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $33893b708b33402d$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $33893b708b33402d$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $33893b708b33402d$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $33893b708b33402d$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $33893b708b33402d$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $33893b708b33402d$var$Config = {
    ...$33893b708b33402d$var$BasicOptions,
    ...$33893b708b33402d$var$MatchOptions,
    ...$33893b708b33402d$var$FuzzyOptions,
    ...$33893b708b33402d$var$AdvancedOptions
};
const $33893b708b33402d$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $33893b708b33402d$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($33893b708b33402d$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $33893b708b33402d$var$FuseIndex {
    constructor({ getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}){
        this.norm = $33893b708b33402d$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($33893b708b33402d$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($33893b708b33402d$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$33893b708b33402d$var$isDefined(doc) || $33893b708b33402d$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$33893b708b33402d$var$isDefined(value)) return;
            if ($33893b708b33402d$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$33893b708b33402d$var$isDefined(value)) continue;
                    if ($33893b708b33402d$var$isString(value) && !$33893b708b33402d$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($33893b708b33402d$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($33893b708b33402d$var$isString(value) && !$33893b708b33402d$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $33893b708b33402d$var$createIndex(keys, docs, { getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $33893b708b33402d$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($33893b708b33402d$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $33893b708b33402d$var$parseIndex(data, { getFn: getFn = $33893b708b33402d$var$Config.getFn, fieldNormWeight: fieldNormWeight = $33893b708b33402d$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $33893b708b33402d$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $33893b708b33402d$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $33893b708b33402d$var$Config.distance, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $33893b708b33402d$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $33893b708b33402d$var$MAX_BITS = 32;
function $33893b708b33402d$var$search(text, pattern, patternAlphabet, { location: location = $33893b708b33402d$var$Config.location, distance: distance = $33893b708b33402d$var$Config.distance, threshold: threshold = $33893b708b33402d$var$Config.threshold, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $33893b708b33402d$var$MAX_BITS) throw new Error($33893b708b33402d$var$PATTERN_LENGTH_TOO_LARGE($33893b708b33402d$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $33893b708b33402d$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $33893b708b33402d$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $33893b708b33402d$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $33893b708b33402d$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $33893b708b33402d$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $33893b708b33402d$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $33893b708b33402d$var$BitapSearch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $33893b708b33402d$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $33893b708b33402d$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $33893b708b33402d$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $33893b708b33402d$var$MAX_BITS), i);
                i += $33893b708b33402d$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $33893b708b33402d$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $33893b708b33402d$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $33893b708b33402d$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $33893b708b33402d$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $33893b708b33402d$var$ExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $33893b708b33402d$var$InverseExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $33893b708b33402d$var$PrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $33893b708b33402d$var$InversePrefixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $33893b708b33402d$var$SuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $33893b708b33402d$var$InverseSuffixExactMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $33893b708b33402d$var$FuzzyMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern, { location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $33893b708b33402d$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $33893b708b33402d$var$IncludeMatch extends $33893b708b33402d$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $33893b708b33402d$var$searchers = [
    $33893b708b33402d$var$ExactMatch,
    $33893b708b33402d$var$IncludeMatch,
    $33893b708b33402d$var$PrefixExactMatch,
    $33893b708b33402d$var$InversePrefixExactMatch,
    $33893b708b33402d$var$InverseSuffixExactMatch,
    $33893b708b33402d$var$SuffixExactMatch,
    $33893b708b33402d$var$InverseExactMatch,
    $33893b708b33402d$var$FuzzyMatch
];
const $33893b708b33402d$var$searchersLen = $33893b708b33402d$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $33893b708b33402d$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $33893b708b33402d$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $33893b708b33402d$var$parseQuery(pattern, options = {}) {
    return pattern.split($33893b708b33402d$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($33893b708b33402d$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $33893b708b33402d$var$searchersLen){
                const searcher = $33893b708b33402d$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $33893b708b33402d$var$MultiMatchSet = new Set([
    $33893b708b33402d$var$FuzzyMatch.type,
    $33893b708b33402d$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $33893b708b33402d$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $33893b708b33402d$var$Config.isCaseSensitive, includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $33893b708b33402d$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $33893b708b33402d$var$Config.ignoreLocation, findAllMatches: findAllMatches = $33893b708b33402d$var$Config.findAllMatches, location: location = $33893b708b33402d$var$Config.location, threshold: threshold = $33893b708b33402d$var$Config.threshold, distance: distance = $33893b708b33402d$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $33893b708b33402d$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($33893b708b33402d$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $33893b708b33402d$var$registeredSearchers = [];
function $33893b708b33402d$var$register(...args) {
    $33893b708b33402d$var$registeredSearchers.push(...args);
}
function $33893b708b33402d$var$createSearcher(pattern, options) {
    for(let i = 0, len = $33893b708b33402d$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $33893b708b33402d$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $33893b708b33402d$var$BitapSearch(pattern, options);
}
const $33893b708b33402d$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $33893b708b33402d$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $33893b708b33402d$var$isExpression = (query)=>!!(query[$33893b708b33402d$var$LogicalOperator.AND] || query[$33893b708b33402d$var$LogicalOperator.OR]);
const $33893b708b33402d$var$isPath = (query)=>!!query[$33893b708b33402d$var$KeyType.PATH];
const $33893b708b33402d$var$isLeaf = (query)=>!$33893b708b33402d$var$isArray(query) && $33893b708b33402d$var$isObject(query) && !$33893b708b33402d$var$isExpression(query);
const $33893b708b33402d$var$convertToExplicit = (query)=>({
        [$33893b708b33402d$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $33893b708b33402d$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $33893b708b33402d$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$33893b708b33402d$var$isExpression(query)) return next($33893b708b33402d$var$convertToExplicit(query));
        if ($33893b708b33402d$var$isLeaf(query)) {
            const key = isQueryPath ? query[$33893b708b33402d$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$33893b708b33402d$var$KeyType.PATTERN] : query[key];
            if (!$33893b708b33402d$var$isString(pattern)) throw new Error($33893b708b33402d$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $33893b708b33402d$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $33893b708b33402d$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($33893b708b33402d$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$33893b708b33402d$var$isExpression(query)) query = $33893b708b33402d$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $33893b708b33402d$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $33893b708b33402d$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $33893b708b33402d$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$33893b708b33402d$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$33893b708b33402d$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $33893b708b33402d$var$transformScore(result, data) {
    data.score = result.score;
}
function $33893b708b33402d$var$format(results, docs, { includeMatches: includeMatches = $33893b708b33402d$var$Config.includeMatches, includeScore: includeScore = $33893b708b33402d$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($33893b708b33402d$var$transformMatches);
    if (includeScore) transformers.push($33893b708b33402d$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $33893b708b33402d$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$33893b708b33402d$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $33893b708b33402d$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $33893b708b33402d$var$FuseIndex)) throw new Error($33893b708b33402d$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $33893b708b33402d$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$33893b708b33402d$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $33893b708b33402d$var$isString(query) ? $33893b708b33402d$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $33893b708b33402d$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($33893b708b33402d$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $33893b708b33402d$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $33893b708b33402d$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$33893b708b33402d$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $33893b708b33402d$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $33893b708b33402d$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($33893b708b33402d$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $33893b708b33402d$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$33893b708b33402d$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$33893b708b33402d$var$isDefined(value)) return [];
        let matches = [];
        if ($33893b708b33402d$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$33893b708b33402d$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$33893b708b33402d$export$2e2bcd8739ae039.version = "6.6.2";
$33893b708b33402d$export$2e2bcd8739ae039.createIndex = $33893b708b33402d$var$createIndex;
$33893b708b33402d$export$2e2bcd8739ae039.parseIndex = $33893b708b33402d$var$parseIndex;
$33893b708b33402d$export$2e2bcd8739ae039.config = $33893b708b33402d$var$Config;
$33893b708b33402d$export$2e2bcd8739ae039.parseQuery = $33893b708b33402d$var$parse;
$33893b708b33402d$var$register($33893b708b33402d$var$ExtendedSearch);


// Products come from the InstaPunchout catalogs API (uploaded and published in the panel),
// for the connection of the current punchout session.
const $50857ca7dedf904b$var$API = "https://punchout.cloud/api/v1/product-catalogs";
const $50857ca7dedf904b$export$ba444f4ef27c9a5 = "/assets/images/wabtec-logo.svg";
function $50857ca7dedf904b$export$7f7554c27e2bfae2(ev) {
    const img = ev.target;
    if (!img.src.endsWith($50857ca7dedf904b$export$ba444f4ef27c9a5)) img.src = $50857ca7dedf904b$export$ba444f4ef27c9a5;
}
async function $50857ca7dedf904b$export$2516233d5dae329e(punchoutId) {
    const res = await fetch(`${$50857ca7dedf904b$var$API}/session/${encodeURIComponent(punchoutId)}/products`);
    if (!res.ok) throw new Error(`products could not be loaded (${res.status})`);
    const list = await res.json();
    return list.map((product)=>({
            sku: product.sku,
            image: product.image_url || $50857ca7dedf904b$export$ba444f4ef27c9a5,
            name: product.name,
            description: product.description || product.name,
            // cents, as the cart has always sent them; price is in thousandths, price_exact keeps
            // prices below a cent (e.g. 0.0107)
            price: (product.price_exact ?? product.price / 1000) * 100,
            unit: product.unit,
            currency: product.currency,
            min_order_quantity: product.min_order_quantity || 1,
            order_increment: product.order_increment || 1
        }));
}
function $50857ca7dedf904b$export$1b70fc833a07a74b(product, quantity) {
    const min = product.min_order_quantity || 1;
    const step = product.order_increment || 1;
    if (Number.isNaN(quantity) || quantity < min) return min;
    return min + Math.ceil((quantity - min) / step) * step;
}
function $50857ca7dedf904b$export$c86caf1be068fb8d(cents) {
    return (cents / 100).toFixed(4).replace(/0{1,2}$/, "");
}
class $50857ca7dedf904b$export$494d083da011ade5 {
    constructor(){
        this.items = [];
    }
}
class $50857ca7dedf904b$export$a1edc412be3e1841 {
    constructor(){
        this.cartClass = "";
        this.search = "";
        this.filter = {};
        this.products = [];
        /** loading | ready | no_session | error */ this.productsStatus = "loading";
        this.productsError = "";
        this.cart = new $50857ca7dedf904b$export$494d083da011ade5();
        if (localStorage.getItem("cart")) this.cart = JSON.parse(localStorage.getItem("cart"));
    }
}
let $50857ca7dedf904b$var$fuse = new (0, $33893b708b33402d$export$2e2bcd8739ae039)([]);
function $50857ca7dedf904b$export$39fd934b9ffc5669(state, action) {
    console.log(action);
    switch(action.type){
        case "clear_cart":
            state.cart.items = [];
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "filter.clear":
            state.search = "";
            state.filter = {};
            break;
        case "search":
            state.search = action.value;
            break;
        case "add":
            const id = $50857ca7dedf904b$var$hash([
                action.product.sku,
                action.options
            ]);
            const item = state.cart.items.find((it)=>it.id == id);
            if (item) item.quantity += action.quantity;
            else state.cart.items.push({
                ...action,
                id: id
            });
            state.cartClass = "animate__animated animate__headShake";
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "quantity":
            // update quantity
            state.cart.items.filter((it)=>it.id == action.id).forEach((it)=>it.quantity = action.quantity);
            // remove if quantity is 0
            state.cart.items = state.cart.items.filter((it)=>it.quantity);
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "products":
            state.products = [
                ...action.products
            ];
            state.productsStatus = "ready";
            $50857ca7dedf904b$var$fuse = new (0, $33893b708b33402d$export$2e2bcd8739ae039)(state.products, {
                keys: [
                    "sku",
                    "name",
                    "description"
                ],
                findAllMatches: true,
                threshold: 0.4
            });
            // a cart kept in the browser gets the current prices and rules; products no longer
            // in the catalog are dropped
            state.cart.items = state.cart.items.flatMap((item)=>{
                const product = state.products.find((it)=>it.sku == item.product.sku);
                return product ? [
                    {
                        ...item,
                        product: product,
                        quantity: $50857ca7dedf904b$export$1b70fc833a07a74b(product, item.quantity)
                    }
                ] : [];
            });
            localStorage.setItem("cart", JSON.stringify(state.cart));
            break;
        case "products.status":
            state.productsStatus = action.status;
            state.productsError = action.error || "";
            break;
        case "filter":
            state.filter = action.filter;
            break;
        case "filter.in":
            state.filter[action.key] = state.filter[action.key] || [];
            if (action.value) state.filter[action.key].push(action.option);
            else state.filter[action.key] = state.filter[action.key].filter((it)=>it !== action.option);
            if (state.filter[action.key].length == 0) delete state.filter[action.key];
            break;
        case "endanimate":
            state.cartClass = "";
            break;
        default:
            break;
    }
    return {
        ...state
    };
}
function $50857ca7dedf904b$export$d76128d007d19019(state) {
    return (state.search ? $50857ca7dedf904b$var$fuse.search(state.search).map((it)=>it.item) : state.products).filter((product)=>{
        for(const key in state.filter){
            const value = state.filter[key];
            if (value == undefined) continue;
            else if (Array.isArray(value)) {
                if (value.includes(product[key])) continue;
            } else if (value == product[key]) continue;
            return false;
        }
        return true;
    });
}
const $50857ca7dedf904b$var$hash = (str)=>{
    if (typeof str !== "string") str = JSON.stringify(str);
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};



function $2a18832c1a6ed571$export$bb558131ed846368(disableDebounce = false, normalize, quantity, setQuantity, onQuantityChange) {
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (disableDebounce) {
            const normalizedQuantity = normalize(quantity);
            setQuantity(normalizedQuantity);
            onQuantityChange?.(normalizedQuantity);
            return;
        }
        const timer = setTimeout(()=>{
            const normalizedQuantity = normalize(quantity);
            setQuantity(normalizedQuantity);
            onQuantityChange?.(normalizedQuantity);
        }, 1000); // 1000ms debounce
        return ()=>clearTimeout(timer);
    }, [
        quantity,
        setQuantity
    ]);
}


const $543d6d2a56ed7d8d$export$a3a6a28ae8823b06 = new (0, $50857ca7dedf904b$export$a1edc412be3e1841)();
const $543d6d2a56ed7d8d$var$StoreContext = (0, $13c40c34b78c8ee2$export$fd42f52fd3ae1109)({
    state: $543d6d2a56ed7d8d$export$a3a6a28ae8823b06,
    dispatch: (action)=>{}
});
const $543d6d2a56ed7d8d$export$39f92e86d1722f3a = ()=>(0, $204a33a7557cbbd0$export$fae74005e78b1a27)($543d6d2a56ed7d8d$var$StoreContext);
async function $543d6d2a56ed7d8d$export$113d76473aa08eea(data) {
    const res = await (await fetch("https://punchout.cloud/cart/" + localStorage.getItem("punchout_id"), {
        body: JSON.stringify({
            cart: {
                Catalog: data
            },
            custom: {}
        }),
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })).text();
    try {
        return JSON.parse(res);
    } catch (e) {
        throw new Error(res);
    }
}
class $543d6d2a56ed7d8d$var$Punchout {
    async submitCart(cart) {
        try {
            this.showBlock();
            const res = await $543d6d2a56ed7d8d$export$113d76473aa08eea(cart);
            if (!res.url || !res.data) {
                alert(res.message || "An error happened with punchout");
                this.hideBlock();
                return;
            }
            const form = this.createPunchoutForm(res);
            localStorage.clear();
            form.submit();
            form.onerror = ()=>this.hideBlock();
            form.onsubmit = ()=>localStorage.removeItem("punchoutSessionId");
        } catch (error) {
            console.log("ERROR", error);
            alert(error.message);
            this.hideBlock();
        }
    }
    createPunchoutForm({ data: data, url: url }) {
        const form = document.createElement("form");
        form.setAttribute("hidden", "true");
        form.setAttribute("method", "POST");
        form.setAttribute("action", url);
        Object.keys(data).forEach((key)=>{
            const input1 = document.createElement("input");
            input1.setAttribute("type", "text");
            input1.setAttribute("name", key);
            input1.setAttribute("value", data[key]);
            form.appendChild(input1);
        });
        document.body.appendChild(form);
        return form;
    }
    showBlock() {
        this._block = this._block || this.createBlock();
        document.body.appendChild(this._block);
    }
    hideBlock() {
        this._block = this._block || this.createBlock();
        document.body.removeChild(this._block);
    }
    createBlock() {
        const block = document.createElement("div");
        block.classList.add("punchout-block");
        const loading = document.createElement("div");
        loading.classList.add("punchout-loading");
        loading.appendChild(document.createElement("div"));
        loading.appendChild(document.createElement("div"));
        block.appendChild(loading);
        return block;
    }
}
const $543d6d2a56ed7d8d$var$punchout = new $543d6d2a56ed7d8d$var$Punchout();
const $543d6d2a56ed7d8d$var$punchoutId = window.location.search.substring(1).split("&").map((pair)=>pair.split("=")).reduce((p, n)=>{
    p[n[0]] = decodeURIComponent(n[1]);
    return p;
}, {}).punchout || localStorage.getItem("punchoutId");
if ($543d6d2a56ed7d8d$var$punchoutId) localStorage.setItem("punchoutId", $543d6d2a56ed7d8d$var$punchoutId);
/** Loads the products of the current punchout session's connection. */ function $543d6d2a56ed7d8d$var$loadProducts(dispatch) {
    const punchoutId = localStorage.getItem("punchout_id");
    if (!punchoutId) {
        dispatch({
            type: "products.status",
            status: "no_session"
        });
        return;
    }
    dispatch({
        type: "products.status",
        status: "loading"
    });
    (0, $50857ca7dedf904b$export$2516233d5dae329e)(punchoutId).then((products)=>dispatch({
            type: "products",
            products: products
        })).catch((error)=>dispatch({
            type: "products.status",
            status: "error",
            error: error.message
        }));
}
function $543d6d2a56ed7d8d$var$App() {
    const [state, dispatch] = (0, $204a33a7557cbbd0$export$13e3392192263954)((0, $50857ca7dedf904b$export$39fd934b9ffc5669), $543d6d2a56ed7d8d$export$a3a6a28ae8823b06);
    const store = {
        state: state,
        dispatch: dispatch
    };
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>$543d6d2a56ed7d8d$var$loadProducts(dispatch), []);
    /*useEffect(() => {
            dispatch({ type: 'products', products: products.products });
            //fetch('/api/v1/products')
              //  .then(res => res.json())
            //     .then(dispatch());
        }, []);*/ return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<${$543d6d2a56ed7d8d$var$StoreContext.Provider} value=${store}>
    <${$543d6d2a56ed7d8d$var$Header}></${$543d6d2a56ed7d8d$var$Header}>

    <${0, $044786338e0e8fe2$export$55185c17a0fcbe46}>
        <${$543d6d2a56ed7d8d$var$Main} default />
        <${$543d6d2a56ed7d8d$var$Login} path="/login/:punchout_id" />
        <${$543d6d2a56ed7d8d$var$CartView} path="/cart" />
        <${$543d6d2a56ed7d8d$var$ProductDetail} path="/p/:sku" />
    </${0, $044786338e0e8fe2$export$55185c17a0fcbe46}>
</${$543d6d2a56ed7d8d$var$StoreContext.Provider}>`;
}
function $543d6d2a56ed7d8d$var$Login({ punchout_id: punchout_id }) {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    localStorage.setItem("punchout_id", punchout_id);
    dispatch({
        type: "clear_cart"
    });
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>$543d6d2a56ed7d8d$var$loadProducts(dispatch), [
        punchout_id
    ]);
    /*      fetch('https://punchout.cloud/api/v1/shopify/products/PT5h2kqpR6jqf3ebhsUkDT?punchout='+punchout_id)
              .then(res => res.json())
               .then(products => dispatch({ type: 'products', products }));
  */ (0, $044786338e0e8fe2$export$4cb887bfde2d34ca)("/");
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)``;
}
function $543d6d2a56ed7d8d$var$ProductsStatus() {
    const { state: state } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const message = {
        loading: "Loading the catalog\u2026",
        no_session: "The catalog is only available in a punchout session. Please start a session from your procurement system.",
        error: `The catalog could not be loaded: ${state.productsError}`
    }[state.productsStatus];
    return message ? (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="alert alert-${state.productsStatus == "loading" ? "info" : "warning"} p-1">${message}</div>` : "";
}
function $543d6d2a56ed7d8d$var$Main() {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="app-content content ecommerce-application">
    <div class="content-wrapper container-xxl p-0">
        <${$543d6d2a56ed7d8d$var$ProductsStatus}></${$543d6d2a56ed7d8d$var$ProductsStatus}>

        <${$543d6d2a56ed7d8d$var$Content}></${$543d6d2a56ed7d8d$var$Content}>
        <${$543d6d2a56ed7d8d$var$Sidebar}></${$543d6d2a56ed7d8d$var$Sidebar}>
    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$Sidebar() {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const brands = Object.keys(state.products.reduce((p, n)=>{
        p[n.brand] = true;
        return p;
    }, {}));
    const categories = Object.keys(state.products.reduce((p, n)=>{
        p[n.category] = true;
        return p;
    }, {}));
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="sidebar-detached sidebar-left">
    <div class="sidebar">
        <!-- Ecommerce Sidebar Starts -->
        <div style="display:none" class="sidebar-shop">
            <div class="row">
                <div class="col-sm-12">
                    <h6 class="filter-heading d-none d-lg-block">Filters</h6>
                </div>
            </div>
            <div class="card pt-0">
                <div class="card-body">
                    <!-- Price Filter starts -
                    <div class="multi-range-price">
                        <h6 class="filter-title mt-0">Multi Range</h6>
                        <ul class="list-unstyled price-range" id="price-range">
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceAll" name="price-range" class="form-check-input"
                                        checked="" />
                                    <label class="form-check-label" for="priceAll">All</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange1" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange1">&lt;=$10</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange2" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange2">$10 - $100</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceARange3" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceARange3">$100 - $500</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange4" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange4">&gt;= $500</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Price Filter ends -->

                    <!-- Price Slider starts 
                    <div class="price-slider">
                        <h6 class="filter-title">Price Range</h6>
                        <div class="price-slider">
                            <div class="range-slider mt-2 noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr"
                                id="price-slider">
                                <div class="noUi-base">
                                    <div class="noUi-connects">
                                        <div class="noUi-connect"
                                            style="transform: translate(29.2786%, 0px) scale(0.404122, 1);">
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-707.214%, 0px); z-index: 5;">
                                        <div class="noUi-handle noUi-handle-lower" data-handle="0" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="51.0"
                                            aria-valuemax="3500.0" aria-valuenow="1500.0" aria-valuetext="1500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">1500</div>
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-303.092%, 0px); z-index: 4;">
                                        <div class="noUi-handle noUi-handle-upper" data-handle="1" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="1500.0"
                                            aria-valuemax="5000.0" aria-valuenow="3500.0" aria-valuetext="3500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">3500</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Price Range ends -->
                    <div id="clear-filters">
                        <button onclick=${()=>dispatch({
            type: "filter.clear"
        })} type="button" class="btn w-100 btn-primary waves-effect waves-float waves-light">Clear
                            All Filters</button>
                    </div>
                    <!-- Categories Starts -->
                    <div id="product-categories">
                        <h6 class="filter-title">Categories</h6>
                        <ul class="list-unstyled categories-list">
                        <li onclick=${(ev)=>dispatch({
            type: "filter",
            filter: {
                ...state.filter,
                category: undefined
            }
        })}>
                                <div class="form-check"  >
                                    <input type="radio" id="category-all" name="category-filter" class="form-check-input"
                                        checked=${state.filter.category == undefined} />
                                    <label class="form-check-label" for="category1">All</label>
                                </div>
                            </li>
                            ${categories.map((category)=>(0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<li onclick=${(ev)=>dispatch({
                type: "filter",
                filter: {
                    ...state.filter,
                    category: category
                }
            })}>
                                <div class="form-check"  >
                                    <input type="radio" id="category-${category}" name="category-filter" class="form-check-input"
                                        checked=${state.filter.category == category} />
                                    <label class="form-check-label" for="category1">${category}</label>
                                </div>
                            </li>`)}
                        </ul>
                    </div>
                    <!-- Categories Ends -->

                    <!-- Brands starts -->
                    <div class="brands">
                        <h6 class="filter-title">Brands</h6>
                        <ul class="list-unstyled brand-list">
                            ${brands.map((brand, index)=>(0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`
                            <li>
                                <div class="form-check">
                                    <input  onchange=${(ev)=>dispatch({
                type: "filter.in",
                key: "brand",
                option: brand,
                value: ev.target.checked
            })} type="checkbox" class="form-check-input" id="productBrand${index}" />
                                    <label class="form-check-label" for="productBrand${index}">${brand}</label>
                                </div>
                                <span></span>
                            </li>`)}
                        </ul>
                    </div>
                    <!-- Brand ends -->

                    <!-- Clear Filters Starts -->
                    
                    <!-- Clear Filters Ends -->
                </div>
            </div>
        </div>
        <!-- Ecommerce Sidebar Ends -->

    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$Content() {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const products = (0, $50857ca7dedf904b$export$d76128d007d19019)(state);
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="content-detached content-right">
    <div class="">
        <!-- E-commerce Content Section Starts -->
        <section id="ecommerce-header">
            <div class="row">
                <div class="col-sm-12">
                    <div class="ecommerce-header-items">
                        <div class="result-toggler">
                            <button class="navbar-toggler shop-sidebar-toggler" type="button" data-bs-toggle="collapse">
                                <span class="navbar-toggler-icon d-block d-lg-none"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-menu">
                                        <line x1="3" y1="12" x2="21" y2="12"></line>
                                        <line x1="3" y1="6" x2="21" y2="6"></line>
                                        <line x1="3" y1="18" x2="21" y2="18"></line>
                                    </svg></span>
                            </button>
                            <div class="search-results">${products.length} results found</div>
                        </div>
                        <div class="view-options d-flex">
                            <!--
                            <div class="btn-group dropdown-sort">
                                <button type="button" class="btn btn-outline-primary dropdown-toggle me-1 waves-effect"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="active-sorting">Featured</span>
                                </button>
                                <div class="dropdown-menu" style="">
                                    <a class="dropdown-item" href="#">Featured</a>
                                    <a class="dropdown-item" href="#">Lowest</a>
                                    <a class="dropdown-item" href="#">Highest</a>
                                </div>
                            </div>
                            <div class="btn-group" role="group">
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option1"
                                    autocomplete="off" checked="" />
                                <label class="btn btn-icon btn-outline-primary view-btn grid-view-btn waves-effect"
                                    for="radio_option1"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-grid font-medium-3">
                                        <rect x="3" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="14" width="7" height="7"></rect>
                                        <rect x="3" y="14" width="7" height="7"></rect>
                                    </svg></label>
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option2"
                                    autocomplete="off" />
                                <label class="btn btn-icon btn-outline-primary view-btn list-view-btn waves-effect"
                                    for="radio_option2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-list font-medium-3">
                                        <line x1="8" y1="6" x2="21" y2="6"></line>
                                        <line x1="8" y1="12" x2="21" y2="12"></line>
                                        <line x1="8" y1="18" x2="21" y2="18"></line>
                                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                                    </svg></label>
                            </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- E-commerce Content Section Starts -->

        <!-- background Overlay when sidebar is shown  starts-->
        <div class="body-content-overlay"></div>
        <!-- background Overlay when sidebar is shown  ends-->

        <!-- E-commerce Search Bar Starts -->
        <section id="ecommerce-searchbar" class="ecommerce-searchbar">
            <div class="row mt-1">
                <div class="col-sm-12">
                    <div class="input-group input-group-merge">
                        <input value=${state.search} onkeyup=${(ev)=>dispatch({
            type: "search",
            value: ev.target.value
        })} type="text" class="form-control search-product" id="shop-search"
                            placeholder="Search Product" aria-label="Search..." aria-describedby="shop-search" />
                        <span class="input-group-text"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-search text-muted">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg></span>
                    </div>
                </div>

            </div>
        </section>
        <!-- E-commerce Search Bar Ends -->

        <!-- E-commerce Products Starts -->
        <section id="ecommerce-products" class="grid-view">
            ${products.map($543d6d2a56ed7d8d$var$ProductCart)}
        </section>
        <!-- E-commerce Products Ends -->

        <!-- E-commerce Pagination Starts
        <section id="ecommerce-pagination">
            <div class="row">
                <div class="col-sm-12">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center mt-2">
                            <li class="page-item prev-item"><a class="page-link" href="#"></a></li>
                            <li class="page-item active"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                            <li class="page-item" aria-current="page"><a class="page-link" href="#">4</a></li>
                            <li class="page-item"><a class="page-link" href="#">5</a></li>
                            <li class="page-item"><a class="page-link" href="#">6</a></li>
                            <li class="page-item"><a class="page-link" href="#">7</a></li>
                            <li class="page-item next-item"><a class="page-link" href="#"></a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section> -->
        <!-- E-commerce Pagination Ends -->

    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$Header() {
    const { state: state } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<nav class="header-navbar navbar-expand-lg navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center"
    data-nav="brand-center">
    <div class="navbar-header d-xl-block d-none">
        <ul class="nav navbar-nav">
            <li class="nav-item"><a class="navbar-brand"
                    href="/"><span class="brand-logo">
                    </span>
                    <h2 class="brand-text mb-0">Stamar Packaging Punchout Catalog</h2>
                </a></li>
        </ul>
    </div>
    <div class="navbar-container d-flex content">

        <ul class="nav navbar-nav align-items-center ms-auto">



            <li class="nav-item dropdown dropdown-cart me-25">
                <a class="nav-link ${state.cartClass}" href="/cart"
                    data-bs-toggle="dropdown"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="feather feather-shopping-cart ficon">
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg><span
                        class="badge rounded-pill bg-primary badge-up cart-item-count">${state.cart.items.reduce((p, n)=>p + n.quantity, 0)}</span></a>

            </li>


        </ul>
    </div>
</nav>`;
}
function $543d6d2a56ed7d8d$var$ProductCart(product) {
    const { dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="card ecommerce-card">
    <div class="item-img text-center">
        <a href="/p/${product.sku}">
            <img class="img-fluid card-img-top" src=${product.image} onerror=${0, $50857ca7dedf904b$export$7f7554c27e2bfae2} alt="img-placeholder" /></a>
    </div>
    <div class="card-body">
        <div class="item-wrapper">
            <div>
                <h6 class="item-price">$${(0, $50857ca7dedf904b$export$c86caf1be068fb8d)(product.price)}</h6>
            </div>
        </div>
        <h6 class="item-name">
            <a class="text-body" href="/p/${product.sku}">${product.name}</a>
            <span class="card-text item-company">By <a href="#" class="company-name">${product.brand}</a></span>
        </h6>
        <p class="card-text item-description">SKU ${product.sku}</p>
    </div>
    <div class="item-options text-center">
        <div class="item-wrapper">
            <div class="item-cost">
                <h4 class="item-price">$${(0, $50857ca7dedf904b$export$c86caf1be068fb8d)(product.price)}</h4>
            </div>
        </div>
        <${$543d6d2a56ed7d8d$var$AddToCartBtn} product=${product}></${$543d6d2a56ed7d8d$var$AddToCartBtn}>
    </div>
</div>`;
}
function $543d6d2a56ed7d8d$var$AddToCartBtn({ product: product }) {
    const { dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<a onclick=${()=>{
        dispatch({
            type: "add",
            product: product,
            quantity: (0, $50857ca7dedf904b$export$1b70fc833a07a74b)(product, 1),
            options: {}
        });
        setTimeout(()=>dispatch({
                type: "endanimate"
            }), 700);
    }} class="btn btn-primary btn-cart waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
    <span class="add-to-cart">Add to cart</span>
</a>`;
}
function $543d6d2a56ed7d8d$var$WhishlistBtn() {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<a href="#" class="btn btn-light btn-wishlist waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
        <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
        </path>
    </svg>
    <span>Wishlist</span>
</a>`;
}
function $543d6d2a56ed7d8d$var$CartView() {
    const { state: state } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const onPunchoutClick = ()=>{
        if (!localStorage.getItem("punchout_id")) return alert("You are not in a punchout session. Please start a session from your procurement system.");
        $543d6d2a56ed7d8d$var$punchout.submitCart({
            items: state.cart.items,
            currency: "USD"
        }).then(()=>{});
    };
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="app-content content ecommerce-application">
        <div class="content-wrapper container-xxl p-0">
        <div class="content-body">
    <div class="bs-stepper checkout-tab-steps">
        <div class="bs-stepper-content">
            <!-- Checkout Place order starts -->
            <div id="step-cart" class="content active dstepper-block" role="tabpanel" aria-labelledby="step-cart-trigger">
                <div id="place-order" class="list-view product-checkout">
                    <!-- Checkout Place Order Left starts -->
                    <div class="checkout-items">
                        ${state.cart.items.map($543d6d2a56ed7d8d$var$CartItemView)}

                    </div>
                    <!-- Checkout Place Order Left ends -->

                    <!-- Checkout Place Order Right starts -->
                    <div class="checkout-options">
                        <div class="card">
                            <div class="card-body">
                                <!--
                                <label class="section-label form-label mb-1">Options</label>
                                <div class="coupons input-group input-group-merge">
                                    <input type="text" class="form-control" placeholder="Coupons" aria-label="Coupons" aria-describedby="input-coupons"/>
                                    <span class="input-group-text text-primary ps-1" id="input-coupons">Apply</span>
                                </div>
                                <hr/>
-->
                                <div class="price-details">
                                    <!--
                                    <h6 class="price-title">Price Details</h6>
                                    <ul class="list-unstyled">
                                        <li class="price-detail">
                                            <div class="detail-title">Total MRP</div>
                                            <div class="detail-amt">$598</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Bag Discount</div>
                                            <div class="detail-amt discount-amt text-success">-25$</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Estimated Tax</div>
                                            <div class="detail-amt">$1.3</div>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">EMI Eligibility</div>
                                            <a href="#" class="detail-amt text-primary">Details</a>
                                        </li>
                                        <li class="price-detail">
                                            <div class="detail-title">Delivery Charges</div>
                                            <div class="detail-amt discount-amt text-success">Free</div>
                                        </li>
                                    </ul>
                                    <hr/>
-->
                                    <ul class="list-unstyled">
                                        <li class="price-detail">
                                            <div class="detail-title detail-total">Total</div>
                                            <div class="detail-amt fw-bolder">$${(state.cart.items.reduce((p, n)=>p + n.product.price * n.quantity, 0) / 100).toFixed(2)}</div>
                                        </li>
                                    </ul>
                                    <button
                                    onclick=${(ev)=>{
        ev.preventDefault();
        onPunchoutClick();
    }} 
                                    type="button" class="btn btn-primary w-100 btn-next place-order waves-effect waves-float waves-light">Punchout</button>
                                </div>
                            </div>
                        </div>
                        <!-- Checkout Place Order Right ends -->
                    </div>
                </div>
                <!-- Checkout Place order Ends -->
            </div>

        </div>
    </div>
        </div>
    </div>
</div>`;
}
/** "Minimum 1000, in multiples of 1000", or nothing when any quantity can be ordered. */ function $543d6d2a56ed7d8d$var$quantityRule(product) {
    const min = product.min_order_quantity || 1;
    const step = product.order_increment || 1;
    const rules = [];
    if (min > 1) rules.push(`Minimum order: ${min}`);
    if (step > 1) rules.push(`in multiples of ${step}`);
    return rules.join(", ");
}
function $543d6d2a56ed7d8d$var$CartItemView(item) {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const min = item.product.min_order_quantity || 1;
    const step = item.product.order_increment || 1;
    const [quantity, setQuantity] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(item.quantity);
    (0, $2a18832c1a6ed571$export$bb558131ed846368)(false, (value)=>(0, $50857ca7dedf904b$export$1b70fc833a07a74b)(item.product, value), quantity, setQuantity, (value)=>{
        dispatch({
            type: "quantity",
            id: item.id,
            quantity: value
        });
    });
    const handleMinus = ()=>{
        const next = Math.max(min, quantity - step);
        setQuantity(next);
        dispatch({
            type: "quantity",
            id: item.id,
            quantity: next
        });
    };
    const handlePlus = ()=>{
        const next = (0, $50857ca7dedf904b$export$1b70fc833a07a74b)(item.product, quantity + step);
        setQuantity(next);
        dispatch({
            type: "quantity",
            id: item.id,
            quantity: next
        });
    };
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="card ecommerce-card">
                            <div class="item-img">
                                <a href="app-ecommerce-details.html">
                                    <img src=${item.product.image} onerror=${0, $50857ca7dedf904b$export$7f7554c27e2bfae2} alt="img-placeholder"/>
                                </a>
                            </div>
                            <div class="card-body">
                                <div class="item-name">
                                    <h6 class="mb-0"><a href="app-ecommerce-details.html" class="text-body">${item.product.name}</a></h6>
                                    <span class="item-company">$${(0, $50857ca7dedf904b$export$c86caf1be068fb8d)(item.product.price)} / ${item.product.unit} <a href="#" class="company-name">${item.product.brand}</a></span>
                                </div>
                                <span class="text-success mb-1">In Stock</span>
                                ${$543d6d2a56ed7d8d$var$quantityRule(item.product) ? (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<small class="text-muted mb-1 d-block">${$543d6d2a56ed7d8d$var$quantityRule(item.product)}</small>` : ""}
                                <div class="item-quantity">
                                    <span class="quantity-title">Qty:</span>
                                    <div class="quantity-counter-wrapper">
                                        <div class="input-group bootstrap-touchspin">
                                            <span class="input-group-btn bootstrap-touchspin-injected">
                                                <button onclick=${handleMinus} class="btn btn-primary bootstrap-touchspin-down" type="button">-</button>
                                            </span>
                                            <input onkeyup=${(ev)=>setQuantity(parseInt(ev.target.value))} value=${quantity} type="number" min=${min} step=${step} class="quantity-counter form-control" placeholder="${min}"/>
                                            <span onclick=${handlePlus} class="input-group-btn bootstrap-touchspin-injected">
                                                <button class="btn btn-primary bootstrap-touchspin-up" type="button">+</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-options text-center">
                                <div class="item-wrapper">
                                    <div class="item-cost">
                                        <h4 class="item-price">$${(item.product.price * item.quantity / 100).toFixed(2)}</h4>
                                    </div>
                                </div>
                                <button onclick=${()=>dispatch({
            type: "quantity",
            id: item.id,
            quantity: 0
        })}  type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x align-middle me-25"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    <span>Remove</span>
                                </button>
                            </div>
                        </div>`;
}
function $543d6d2a56ed7d8d$var$ProductPreview(product, addToCart) {
    return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div>${product.name} :${(0, $50857ca7dedf904b$export$c86caf1be068fb8d)(product.price)}

    <button onclick=${(ev)=>addToCart(product, 1)}>Add to cart</button>
</div>`;
}
function $543d6d2a56ed7d8d$var$Product({ productId: productId }) {}
function $543d6d2a56ed7d8d$var$ProductDetail({ sku: sku }) {
    const { state: state, dispatch: dispatch } = $543d6d2a56ed7d8d$export$39f92e86d1722f3a();
    const product = state.products.find((it)=>it.sku == sku);
    const min = product?.min_order_quantity || 1;
    const step = product?.order_increment || 1;
    const [quantity, setQuantity] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(min);
    (0, $2a18832c1a6ed571$export$bb558131ed846368)(false, (value)=>product ? (0, $50857ca7dedf904b$export$1b70fc833a07a74b)(product, value) : value, quantity, setQuantity);
    // opened directly, the page renders before the products are loaded: start from the minimum once they are
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (product) setQuantity((0, $50857ca7dedf904b$export$1b70fc833a07a74b)(product, quantity));
    }, [
        product?.sku,
        product?.min_order_quantity,
        product?.order_increment
    ]);
    if (product) return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<div class="content-wrapper container-xxl p-0 animate__animated animate__fadeIn">
    
    <div class="content-body">
    <!-- app e-commerce details start -->
    <section class="app-ecommerce-details">
        <div class="card">
            <!-- Product Details starts -->
            <div class="card-body">
                <div class="row my-2">
                    <div class="col-12 col-md-5 d-flex align-items-center justify-content-center mb-2 mb-md-0">
                        <div class="d-flex align-items-center justify-content-center">
                            <img src=${product.image} onerror=${0, $50857ca7dedf904b$export$7f7554c27e2bfae2} class="img-fluid product-img" alt="product image"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-7">
                        <h4>${product.name}</h4>
                        <!--<span class="card-text item-company">By <a href="#" class="company-name">${product.brand}</a></span>-->
                        <div class="ecommerce-details-price d-flex flex-wrap mt-1">
                            <h4 class="item-price me-1">$${(0, $50857ca7dedf904b$export$c86caf1be068fb8d)(product.price)} / ${product.unit}</h4>
                            <!--
                            <ul class="unstyled-list list-inline ps-1 border-start">
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star filled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                                <li class="ratings-list-item"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star unfilled-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></li>
                            </ul>
    -->
                        </div>
                        <p class="card-text">Available - <span class="text-success">In stock</span></p>
                        ${$543d6d2a56ed7d8d$var$quantityRule(product) ? (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<p class="card-text text-muted">${$543d6d2a56ed7d8d$var$quantityRule(product)}</p>` : ""}
                        <p class="card-text">
                            ${product.description}
                        </p>
                        <div class="item-quantity" style="display:flex;align-items:center">
                            <span class="quantity-title">Qty:</span>
                            <div class="quantity-counter-wrapper">
                                <div class="input-group bootstrap-touchspin">
                                    <span class="input-group-btn bootstrap-touchspin-injected">
                                        <button onclick=${()=>setQuantity(Math.max(min, quantity - step))} class="btn btn-primary bootstrap-touchspin-down" type="button">-</button>
                                    </span>
                                    <input oninput=${(ev)=>setQuantity(parseInt(ev.target.value))} value=${quantity} type="number" min=${min} step=${step} class="quantity-counter form-control" placeholder=${min}/>
                                    <span onclick=${()=>setQuantity((0, $50857ca7dedf904b$export$1b70fc833a07a74b)(product, quantity + step))} class="input-group-btn bootstrap-touchspin-injected">
                                        <button class="btn btn-primary bootstrap-touchspin-up" type="button">+</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!--
                        <ul class="product-features list-unstyled">
                            <li><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> <span>Free Shipping</span></li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                                <span>EMI options available</span>
                            </li>
                        </ul>
   
                        <hr/>
                        <div class="product-color-options">
                            <h6>Colors</h6>
                            <ul class="list-unstyled mb-0">
                                <li class="d-inline-block selected">
                                    <div class="color-option b-primary">
                                        <div class="filloption bg-primary"></div>
                                    </div>
                                </li>
                                <li class="d-inline-block">
                                    <div class="color-option b-success">
                                        <div class="filloption bg-success"></div>
                                    </div>
                                </li>
                                <li class="d-inline-block">
                                    <div class="color-option b-danger">
                                        <div class="filloption bg-danger"></div>
                                    </div>
                                </li>
                                <li class="d-inline-block">
                                    <div class="color-option b-warning">
                                        <div class="filloption bg-warning"></div>
                                    </div>
                                </li>
                                <li class="d-inline-block">
                                    <div class="color-option b-info">
                                        <div class="filloption bg-info"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <hr/> -->
                        <div class="d-flex flex-column flex-sm-row pt-1">
                            <a onclick=${()=>dispatch({
            type: "add",
            product: product,
            quantity: (0, $50857ca7dedf904b$export$1b70fc833a07a74b)(product, quantity),
            options: {}
        })} class="btn btn-primary btn-cart me-0 me-sm-1 mb-1 mb-sm-0 waves-effect waves-float waves-light">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart me-50"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                <span class="add-to-cart">Add to cart</span>
                            </a>
                            <div style="display:none" class="btn-group dropdown-icon-wrapper btn-share">
                                <button type="button" class="btn btn-icon hide-arrow btn-outline-secondary dropdown-toggle waves-effect" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-share-2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end">
                                    <a href="#" class="dropdown-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                                    </a>
                                    <a href="#" class="dropdown-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-twitter"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
                                    </a>
                                    <a href="#" class="dropdown-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                                    </a>
                                    <a href="#" class="dropdown-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-instagram"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Product Details ends -->

        </div>
    </section>
    <!-- app e-commerce details end -->

</div></div>`;
    else return (0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`loading`;
}
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)((0, $5d836d6e65da64f6$export$c0bb0b647f701bb5)`<${$543d6d2a56ed7d8d$var$App} />`, document.body);


//# sourceMappingURL=index.258c08c9.js.map
